export default "__VITE_ASSET__C3BnT2bw__"